module.exports = __webpack_public_path__ + "static/13-e55f7b53803fa345df1bafd1c53a263e.jpg";